<template>
    <div class='content'>
        asdfasdfasdfasdfa
       <input v-model="cpf" type="text" placehoder="cpf">
        <button @click="login"> login </button>
        
        {{this.$store.getters.user}} 
    
    </div>
</template>

<script>
import api from "@/api"
export default {
    data(){
        return {cpf:''}
    },
    methods: {
        login:function(){
                this.$store.dispatch('logmeasuser', this.cpf)

        }
    }    
}

</script>